import React from 'react';
import PropTypes from 'prop-types';

import css from 'styles/components/search/searchFeedback.scss';

const SearchFeedbackSubmitted = (_, { marketplace: { vocUrl }, testId }) => (
  <div className={css.searchFeedback}>
    <p>
        Thank you! For additional feedback, take
      {' '}
      <a
        href={`${vocUrl}?source=search`}
        data-test-id={testId('searchSurvey')}
        target="_blank"
        rel="noopener noreferrer">this survey</a>.
    </p>
  </div>
);

SearchFeedbackSubmitted.contextTypes = {
  testId: PropTypes.func.isRequired,
  marketplace: PropTypes.object.isRequired
};

export default SearchFeedbackSubmitted;
